export default __webpack_public_path__ + "static/4.5cfdd0afdaa3416b75373903efacd53d.png";